<template>
    <div id="nav" class="navigation-bar">
        <div class="logo" @click="goHome"><i class="gf gf-angle-left"></i></div>
        <div class="project-selector">
            <custom-combo-box :options="ProjectOptions" @userSelectOption="onProjectSelectorChange"
                              :dropdown-menu-offset-top="0"
                              theme="primary"
                              :initial-value="projectId" :block-select="true"></custom-combo-box>
        </div>
        <div class="tabs">
            <router-link :to="{name: 'document_finder', params: {pid: projectId}}"><span class="content"><i
                    class="gf gf-overview"></i> <span class="text">Overview</span></span>
            </router-link>
            <router-link :to="{name: 'documents', params: {pid: projectId}}"><span class="content"><i
                    class="gf gf-workplatform"></i> <span
                    class="text">Work Platform</span></span><span
                    class="open-doc-count badge"
                    v-if="openGlobalDocumentIds.length">{{ openGlobalDocumentIds.length }}</span>
            </router-link>
        </div>
        <div class="toolbox" v-if="userInfo">
            <work-mode-switch></work-mode-switch>
            <account-button :user-info="userInfo"></account-button>
        </div>
    </div>
</template>

<script>
import {allProjectOptions} from "@/config";
import CustomComboBox from "@/InputControls/CustomComboBox";
import AccountButton from "@/components/AccountButton";
import WorkModeSwitch from "@/components/WorkModeSwitch";
import {authHelper} from "@/utils";

export default {
    name: "NavigationBar",
    components: {WorkModeSwitch, AccountButton, CustomComboBox},
    methods: {
        logout() {
            this.eventHub.$emit('doLogout');
        },
        goHome() {
            let query = {};
            let v = this.$store.state.homeLastSelectedViewMode;
            if (v) {
                query['v'] = v;
            }
            this.$router.push({name: 'home', query,})
        },
        onProjectSelectorChange(value) {
            const {params} = this.$route;
            if (value && params.pid !== value) {
                params.pid = value;
                this.$router.push({params});
            }
        }
    },
    computed: {
        openGlobalDocumentIds() {
            return this.allProjectsOpenGlobalDocumentIds[this.projectId] || [];
        },
        userInfo() {
            return this.$store.state.userInfo
        },
        allProjectsOpenGlobalDocumentIds() {
            return this.$store.state.openGlobalDocumentIds;
        },
        ProjectOptions() {
            return allProjectOptions.filter(item => {
                return authHelper.getCanAccessProjects().indexOf(item.value) >= 0;
            }).map(item => {
                const {value, label} = item;
                let note;
                const openGdis = this.allProjectsOpenGlobalDocumentIds[value] || [];
                if (openGdis.length) {
                    note = ` (${openGdis.length})`;
                }
                return {value, label, note};
            })
        }
    },
    props: {
        projectId: String,
    },
}
</script>

<style lang="scss" scoped>
@import "../assets/variables";

#nav {
    background-color: darken($primary-purple, 3);
    color: white;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 1rem;
    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 2px 6px 2px rgba(60, 64, 67, .15);

    .tabs {
        a {
            color: inherit;
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            height: 48px;
            margin-top: 2px;
            padding: 0 1rem 0;
            position: relative;
            user-select: none;

            .open-doc-count {
                position: absolute;
                top: 4px;
                left: 100%;
                margin-left: -16px;
            }

            &.router-link-active {
                box-shadow: inset 0 -2px 0 0;
                pointer-events: none;

                .content {
                    opacity: 1;
                }
            }

            i {
                margin-right: 0.5rem;
                font-size: 1.2em;
            }

            .content {
                display: flex;
                align-items: center;
                opacity: 0.8;
            }
        }
    }

    .logo {
        font-size: 1rem;
        display: inline-flex;
        align-items: center;
        color: #dfdafb;
        text-shadow: 1px 1px 0 rgba(black, 0.1);
        cursor: pointer;

        &:hover {
            color: white;
            text-shadow: 1px 1px 0 rgba(black, 0.15);
        }
    }

    .toolbox {
        margin-left: auto;
        display: flex;
        align-items: center;

        & > *:not(:last-child) {
            margin-right: 0.8rem;
        }
    }
}

.project-selector {
    padding-right: 1.25rem;
    margin-right: 1.25rem;
    border-right: 2px solid rgba(white, 0.4);
}
</style>
<style lang="scss">
.navigation-bar {
    .toolbox {
        .button-account.pure, .button-settings.pure {
            color: white;
            /*font-size: 1.2rem;*/

            &:hover {
                opacity: 0.8;
            }
        }

        .active {
            .button-account.pure, .button-settings.pure {
                opacity: 0.8;
            }
        }
    }
}

.project-selector {
    .simple-dropdown {
        .trigger {
            padding-left: 1.05rem;
        }
    }
}
</style>
